import { api } from '../config/api';

export const categoryService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.active_only === true || params.active_only === 'true') {
      queryParams.append('is_active', 'true');
    }
    if (params.view) queryParams.append('view', params.view);
    
    const queryString = queryParams.toString();
    const endpoint = `/categories/${queryString ? `?${queryString}` : ''}`;
    return await api.get(endpoint, { normalizeListResponse: true });
  },

  getFlat: async (params = {}) => {
    return categoryService.getAll({ ...params, view: 'flat' });
  },

  getById: async (id) => {
    return await api.get(`/categories/${id}/`);
  },

  create: async (categoryData) => {
    return await api.post('/categories/', categoryData);
  },

  update: async (id, categoryData) => {
    return await api.put(`/categories/${id}/`, categoryData);
  },

  delete: async (id) => {
    return await api.delete(`/categories/${id}/`);
  },
};

